import { render, staticRenderFns } from "./BoxItemCanje.vue?vue&type=template&id=5ff94f5a&"
import script from "./BoxItemCanje.vue?vue&type=script&lang=js&"
export * from "./BoxItemCanje.vue?vue&type=script&lang=js&"
import style0 from "./BoxItemCanje.vue?vue&type=style&index=0&id=5ff94f5a&prod&lang=css&"
import style1 from "./BoxItemCanje.vue?vue&type=style&index=1&id=5ff94f5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports